import { api } from "@shared/services/api-client";
import type { ApiResponse, PaginatedResponse } from "@shared/types/api.types";
import type {
  AdminArticleRow,
  ArticleDetail,
  ArticleInput,
  ArticleListFilter,
  AssessmentOption,
  PreviewResult,
  StatusAction,
} from "./types";

const base = "/admin/articles";
const one = (id: string) => `${base}/${encodeURIComponent(id)}`;

export async function listArticles(filter: ArticleListFilter): Promise<PaginatedResponse<AdminArticleRow>> {
  const params = new URLSearchParams();
  if (filter.status) params.set("status", filter.status);
  if (filter.kind) params.set("kind", filter.kind);
  if (filter.q) params.set("q", filter.q);
  if (filter.placeholder) params.set("placeholder", "true");
  params.set("page", String(filter.page));
  params.set("limit", String(filter.limit));
  return api.get<PaginatedResponse<AdminArticleRow>>(`${base}?${params.toString()}`);
}

const data = async <T>(request: Promise<ApiResponse<T>>): Promise<T> => (await request).data;

export const getArticle = (id: string) => data(api.get<ApiResponse<ArticleDetail>>(one(id)));

export const createArticle = (input: ArticleInput) => data(api.post<ApiResponse<ArticleDetail>>(base, input));

export const updateArticle = (id: string, input: ArticleInput) =>
  data(api.put<ApiResponse<ArticleDetail>>(one(id), input));

export const changeStatus = (id: string, action: StatusAction) =>
  data(api.post<ApiResponse<ArticleDetail>>(`${one(id)}/${action}`));

export const setFeaturedDate = (id: string, date: string | null) =>
  data(api.put<ApiResponse<ArticleDetail>>(`${one(id)}/feature`, { date }));

export const deleteArticle = async (id: string): Promise<void> => {
  await api.delete(one(id));
};

export const previewBody = (bodySource: string) =>
  data(api.post<ApiResponse<PreviewResult>>(`${base}/preview`, { bodySource }));

/** The test list used by the "Tes terkait" dropdown. */
export const listAssessments = () => data(api.get<ApiResponse<AssessmentOption[]>>("/admin/assessment-intros"));
